<!-- eslint-disable vue/multi-word-component-names -->
<script>
import ajax from "./ajax";
import UploadDragger from "./upload-dragger.vue";

export default {
  components: {
    UploadDragger,
  },
  inject: ["uploader"],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    type: String,
    action: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "file",
    },
    // eslint-disable-next-line vue/require-default-prop
    data: Object,
    // eslint-disable-next-line vue/require-default-prop
    headers: Object,
    // eslint-disable-next-line vue/require-default-prop
    withCredentials: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    multiple: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    accept: String,
    // eslint-disable-next-line vue/require-default-prop
    onStart: Function,
    // eslint-disable-next-line vue/require-default-prop
    onProgress: Function,
    // eslint-disable-next-line vue/require-default-prop
    onSuccess: Function,
    // eslint-disable-next-line vue/require-default-prop
    onError: Function,
    // eslint-disable-next-line vue/require-default-prop
    beforeUpload: Function,
    // eslint-disable-next-line vue/require-default-prop
    drag: Boolean,
    onPreview: {
      type: Function,
      default: function () {},
    },
    onRemove: {
      type: Function,
      default: function () {},
    },
    // eslint-disable-next-line vue/require-default-prop
    fileList: Array,
    // eslint-disable-next-line vue/require-default-prop
    autoUpload: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    listType: String,
    httpRequest: {
      type: Function,
      default: ajax,
    },
    // eslint-disable-next-line vue/require-default-prop
    disabled: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    limit: Number,
    // eslint-disable-next-line vue/require-default-prop
    onExceed: Function,
  },

  data() {
    return {
      mouseover: false,
      reqs: {},
    };
  },

  methods: {
    isImage(str) {
      return str.indexOf("image") !== -1;
    },
    handleChange(ev) {
      const files = ev.target.files;

      if (!files) return;
      this.uploadFiles(files);
    },
    uploadFiles(files) {
      if (this.limit && this.fileList.length + files.length > this.limit) {
        this.onExceed && this.onExceed(files, this.fileList);
        return;
      }

      let postFiles = Array.prototype.slice.call(files);
      if (!this.multiple) {
        postFiles = postFiles.slice(0, 1);
      }

      if (postFiles.length === 0) {
        return;
      }

      postFiles.forEach((rawFile) => {
        this.onStart(rawFile);
        if (this.autoUpload) this.upload(rawFile);
      });
    },
    upload(rawFile) {
      this.$refs.input.value = null;

      if (!this.beforeUpload) {
        return this.post(rawFile);
      }

      const before = this.beforeUpload(rawFile);
      if (before && before.then) {
        before.then(
          (processedFile) => {
            const fileType = Object.prototype.toString.call(processedFile);

            if (fileType === "[object File]" || fileType === "[object Blob]") {
              if (fileType === "[object Blob]") {
                processedFile = new File([processedFile], rawFile.name, {
                  type: rawFile.type,
                });
              }
              for (const p in rawFile) {
                // eslint-disable-next-line no-prototype-builtins
                if (rawFile.hasOwnProperty(p)) {
                  processedFile[p] = rawFile[p];
                }
              }
              this.post(processedFile);
            } else {
              this.post(rawFile);
            }
          },
          () => {
            this.onRemove(null, rawFile);
          },
        );
      } else if (before !== false) {
        this.post(rawFile);
      } else {
        this.onRemove(null, rawFile);
      }
    },
    abort(file) {
      const { reqs } = this;
      if (file) {
        let uid = file;
        if (file.uid) uid = file.uid;
        if (reqs[uid]) {
          reqs[uid].abort();
        }
      } else {
        Object.keys(reqs).forEach((uid) => {
          if (reqs[uid]) reqs[uid].abort();
          delete reqs[uid];
        });
      }
    },
    post(rawFile) {
      const { uid } = rawFile;
      const options = {
        headers: this.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: this.data,
        filename: this.name,
        action: this.action,
        onProgress: (e) => {
          this.onProgress(e, rawFile);
        },
        onSuccess: (res) => {
          this.onSuccess(res, rawFile);
          delete this.reqs[uid];
        },
        onError: (err) => {
          this.onError(err, rawFile);
          delete this.reqs[uid];
        },
      };
      const req = this.httpRequest(options);
      this.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    },
    handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    },
    handleKeydown(e) {
      if (e.target !== e.currentTarget) return;
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.handleClick();
      }
    },
  },

  render() {
    let {
      handleClick,
      drag,
      name,
      handleChange,
      multiple,
      accept,
      listType,
      uploadFiles,
      disabled,
      handleKeydown,
    } = this;
    const data = {
      class: {
        "el-upload": true,
      },
      on: {
        click: handleClick,
        keydown: handleKeydown,
      },
    };
    data.class[`el-upload--${listType}`] = true;
    return (
      <div {...data} tabindex="0">
        {drag ? (
          <upload-dragger disabled={disabled} on-file={uploadFiles}>
            {this.$slots.default}
          </upload-dragger>
        ) : (
          this.$slots.default
        )}
        <input
          class="el-upload__input"
          type="file"
          ref="input"
          name={name}
          on-change={handleChange}
          multiple={multiple}
          accept={accept}
        />
      </div>
    );
  },
};
</script>
